import Vue from 'vue'
import App from './App.vue'
import router from './router'

// 이건 Vue가 처음 실행될때 나오는 경고문을 출력할지를 정하는 것이다. 상용이라면 false로 설정하자
Vue.config.productionTip = false;  

new Vue({
  el: '#app',
  router,
  render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js